export default __webpack_public_path__ + "static/media/inicio1-min.3ff8d4a2.jpg";